const PLACEHOLDER_LITERAL_REGEX = /\{\{\s*[\w.]+\s*\}\}/g;

/** Every `{{ placeholder }}` literal in `text`, sorted, duplicates kept. */
export const extractPlaceholderLiterals = (text: string): string[] =>
  [...text.matchAll(PLACEHOLDER_LITERAL_REGEX)].map((occurrence) => occurrence[0]).sort();

const countLiterals = (literals: string[]): Map<string, number> =>
  literals.reduce((counts, literal) => {
    counts.set(literal, (counts.get(literal) ?? 0) + 1);
    return counts;
  }, new Map<string, number>());

/**
 * True when `proposed` keeps every placeholder literal of `original` the same number of times,
 * and every literal it introduces is one of `allowedAdditions` used exactly once. Without
 * `allowedAdditions` this is an identity check. The server applies the same rule in
 * `hasAllowedPlaceholderLiterals`; keep the two in step.
 */
export const comparePlaceholderLiterals = (
  original: string,
  proposed: string,
  allowedAdditions: readonly string[] = []
): boolean => {
  const originalCounts = countLiterals(extractPlaceholderLiterals(original));
  const proposedCounts = countLiterals(extractPlaceholderLiterals(proposed));

  const keepsEveryOriginal = [...originalCounts].every(
    ([literal, count]) => proposedCounts.get(literal) === count
  );
  const introducesOnlyAllowed = [...proposedCounts].every(
    ([literal, count]) =>
      originalCounts.has(literal) || (count === 1 && allowedAdditions.includes(literal))
  );

  return keepsEveryOriginal && introducesOnlyAllowed;
};
